import { useState } from 'react'
import { stateAllOption } from '@truepill/tpos-types'
import MultiSelect, { type MultiSelectOption } from 'components/MultiSelect'
import { usePlusClient } from 'providers/VisionRouter'
import { getStatesInWeatherZone, getAllWeatherZones } from 'utils'

type WeatherZonesSelectProps = {
  label: string
  variant?: 'small' | 'large'
}

const WeatherZonesSelect = (props: WeatherZonesSelectProps): JSX.Element => {
  const { label, variant = 'large' } = props
  const { currentLocation, routeToMergedQuery } = usePlusClient()
  const [allOptionsChecked, setAllOptionsChecked] = useState(false)

  const multiSelectOptions: MultiSelectOption<string>[] = [
    { label: 'Select All', value: 'All', selectAll: true },
    ...getAllWeatherZones().map(option => ({ label: `Zone ${option}`, value: option.toString() })),
  ]

  const selectedWeatherZonesFromQuery = currentLocation?.queryMap?.weatherZones || []
  const multiSelectValues = allOptionsChecked ? multiSelectOptions.map(opt => opt.value) : selectedWeatherZonesFromQuery

  return (
    <MultiSelect
      label={label}
      value={multiSelectValues}
      placeholder="Select weather zones"
      options={multiSelectOptions}
      onChange={values => {
        if (values.includes('All')) {
          // when "Select All" is chosen, select all weather zones and all states
          routeToMergedQuery({
            states: [stateAllOption],
            noStates: undefined,
            weatherZones: undefined,
          })
          setAllOptionsChecked(true)
        } else if (!values?.length) {
          // when no weather zones are selected, clear weather zones and states (no filtering by state)
          routeToMergedQuery({
            states: [stateAllOption],
            noStates: undefined,
            weatherZones: undefined,
          })
          setAllOptionsChecked(false)
        } else {
          // update weather zones and states to include newly selected zone
          const newSelectedStates = values.flatMap(zone => getStatesInWeatherZone(Number(zone)))
          routeToMergedQuery({
            states: newSelectedStates,
            noStates: undefined,
            weatherZones: values,
          })
          setAllOptionsChecked(false)
        }
      }}
      variant={variant}
    />
  )
}

export default WeatherZonesSelect
